var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useMutation } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { translate } from '@utils/i18n';
import { createKitOrder } from '../services/SprinklerSamplingService';
import { NAMESPACE } from '../constants';
export function useKitOrderMutation() {
    return useMutation({
        mutationFn: (_a) => __awaiter(this, [_a], void 0, function* ({ buildingId, formData }) {
            var _b;
            const response = yield createKitOrder(buildingId, formData);
            if (response.error) {
                throw new Error(((_b = response.error.errors) === null || _b === void 0 ? void 0 : _b.join(', ')) || response.error.message);
            }
        }),
        onSuccess: () => {
            toast.success(translate('kit_order_form.success', { namespace: NAMESPACE }));
        }
    });
}
